import { createClient } from '@supabase/supabase-js'

// Browser client (anon key). Tenant isolation is enforced by Supabase RLS using
// the signed-in user's JWT (app_metadata.company_id) — no service role here.
export const supabase = createClient(
  import.meta.env.VITE_SUPABASE_URL as string,
  import.meta.env.VITE_SUPABASE_ANON_KEY as string,
  {
    auth: {
      persistSession: true,
      autoRefreshToken: true,
      detectSessionInUrl: true,
    },
  },
)
